// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  token: __t.string().primaryKey(),
  identity: __t.identity(),
  roomId: __t.u64().name("room_id"),
  issuedAt: __t.timestamp().name("issued_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
